(function($) {

	'use strict';

	var init = function() {

		if($('.fp-products__slider').length > 0) {
            brandsCarousel();
        }
        
	};

	var brandsCarousel = function() {

        var $brands = $('.fp-products__slider');

        $brands.owlCarousel({
            loop:true,
            margin:0,
            nav:true,
            touchDrag:true,
            mouseDrag:true,
            smartSpeed:600,
            items:4,
            autoplay:true,
            autoplayTimeout: 6000,
            responsive: {
                0 : {
                    items:2,
                },
                375: {
                    items:3,
                },
                767 : {
                    items:4,
                }
            }
        });

    }

	$(document).ready(function() {
		init();
	});

})(jQuery);